import loadable from '@loadable/component';
import query from './query.graphql';

const ChangelogLandingPage = loadable(() =>
  import(/* webpackChunkName: "expert" */ './landing-page')
);

ChangelogLandingPage.graphQL = query;

ChangelogLandingPage.variables = () => ({});

export default ChangelogLandingPage;
